import { render, staticRenderFns } from "./VoerroTagsInput.vue?vue&type=template&id=769c2e48&"
import script from "./VoerroTagsInput.vue?vue&type=script&lang=js&"
export * from "./VoerroTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./VoerroTagsInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports